import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OrganizationHeritageType } from '../model/organization/organization-heritage-type.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ImpactTypeService {
  private httpClient = inject(HttpClient);

  public getImpactTypeList(): Observable<OrganizationHeritageType[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/impact-types`,
    ).pipe(
      map((responseList: any[]): OrganizationHeritageType[] => (responseList ?? []).map(
        (response: any): OrganizationHeritageType => OrganizationHeritageType.createFromApi(response),
      )),
    );
  }
}
